import { createPortal } from "react-dom";
import "./styles/gallery.modal.css";

export default function ImageModal({ data, onClose }) {
  if (!data) return null;

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-box"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>×</button>

      <div className="modal-content">
  <div className="modal-image">
    <img src={data.src} alt="" />
  </div>

  <div className="modal-text">
    <h3>{data.title}</h3>
    <p>{data.tags.join(" ")}</p>
    
            <a
              href={data.blogUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-btn"
            >
              BLOG
            </a>
          </div>
        </div>
      </div>
    </div>,
    document.body   
  );
}